import { WorkOrder } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface WorkOrderState extends EntityState<WorkOrder> {}

export const workOrderAdapter: EntityAdapter<WorkOrder> = createEntityAdapter<WorkOrder>({
  selectId: (workOrder: WorkOrder) => workOrder.id
});
export const initialWorkOrderState: WorkOrderState = workOrderAdapter.getInitialState({});
